module.exports = "/public/webpack/img/icon_help_question596496698daecb70868d01db54a4546b.png";